import React from "react";
import { AGENT_READ_ONLY_MESSAGE, useAccountConfig } from "../hooks/useAccountConfig";

// DNC-390: the "you may look but not touch" notice shown at the top of every
// TrustCall page an Agent opens. One component so the copy stays identical
// across the five pages that render it.
//
// Gates itself: canWrite is false while monitor-info is in flight, which is right
// for a button but would flash this banner at Admins on a cold load.
const AgentReadOnlyBanner: React.FC = () => {
  const { data } = useAccountConfig();
  if (!data || data.canWrite) return null;

  return (
    <div className="alert alert-warning py-2 mb-3" role="status">
      {AGENT_READ_ONLY_MESSAGE}
    </div>
  );
};

export default AgentReadOnlyBanner;
